import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import catchErrors from "../../helpers/catchErrors";
import { useSelector } from "react-redux";
import { deleteOne } from "../../helpers/events";
import { Button } from "semantic-ui-react";
import Snackbar from "@material-ui/core/Snackbar";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Slide from "@material-ui/core/Slide";
import MuiAlert from "@material-ui/lab/Alert";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

export default function DeleteButton({ id, resetForm, isDisabled }) {
  const [open, setOpen] = React.useState(false);
  const [alertOpen, setAlertOpen] = React.useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const { user } = useSelector((state) => ({ ...state }));

  let history = useHistory();

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
    history.push("/user/events");
  };

  const handleDelete = async () => {
    setError("");
    setLoading(true);
    try {
      const authtoken = user.token;
      console.log(authtoken);
      const response = await deleteOne(authtoken, id);
      if (response.status === 200) {
        setAlertOpen(true);
        resetForm(true);

        setOpen(false);
      }
    } catch (error) {
      catchErrors(error, setError);
    } finally {
      setLoading(false);
      // console.log(values);
    }
  };
  return (
    <>
      <Button
        style={{ width: "100%", marginTop: 15 }}
        basic
        type="button"
        color="orange"
        onClick={handleClickOpen}
        disabled={isDisabled}
      >
        Delete Event
      </Button>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title">
          {"Are you sure you want to delete the event?"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            This will delete the event permanently and you will not be able to
            restore it.{" "}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} basic color="violet">
            Cancel
          </Button>
          <Button onClick={handleDelete} color="red">
            Delete now!
          </Button>
        </DialogActions>
      </Dialog>
      <Snackbar
        open={alertOpen}
        autoHideDuration={4000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity="success">
          <h3>Event Deleted successfully!</h3>
          <h4>You will now be redirected to your events...</h4>
        </Alert>
      </Snackbar>
    </>
  );
}
